<svelte:options tag="cdlc-live-chat-icon" />

<script>
  import debug from 'debug';
  import _ from 'lodash';

  const log = debug('cdlc:LiveChatIcon');

  export let message_total;

  export let client_typing;
</script>

<div class="cdlc-LiveChatIcon">
  {#if client_typing}
    <div class="typingIcon">
      <svg
        width="55"
        height="51"
        viewBox="0 0 55 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d)">
          <path
            d="M28 9.75C18.0156 9.75 10 16.3594 10 24.375C10 27.8906 11.4766 31.0547 14.0078 33.5859C13.0938 37.1719 10.1406 40.2656 10.1406 40.3359C10 40.4766 9.92969 40.7578 10 40.9688C10.1406 41.1797 10.2812 41.25 10.5625 41.25C15.2031 41.25 18.7188 39.0703 20.4062 37.6641C22.7266 38.5078 25.2578 39 28 39C37.9141 39 46 32.4609 46 24.375C46 16.3594 37.9141 9.75 28 9.75Z"
            fill="white"
          />
          <path
            d="M14.0078 33.5859L14.9768 33.8329L15.1174 33.2813L14.7149 32.8788L14.0078 33.5859ZM10.1406 40.3359L10.8477 41.043L11.1406 40.7502V40.3359H10.1406ZM10 40.9688L9.05132 41.285L9.09367 41.412L9.16795 41.5234L10 40.9688ZM20.4062 37.6641L20.748 36.7243L20.2077 36.5278L19.7661 36.8958L20.4062 37.6641ZM28 8.75C17.6628 8.75 9 15.6268 9 24.375H11C11 17.0919 18.3685 10.75 28 10.75V8.75ZM9 24.375C9 28.1901 10.6076 31.6 13.3007 34.293L14.7149 32.8788C12.3455 30.5094 11 27.5911 11 24.375H9ZM13.0388 33.3389C12.624 34.9662 11.7319 36.5228 10.9095 37.7098C10.5027 38.2969 10.1223 38.7804 9.84227 39.1228C9.70177 39.2945 9.58797 39.4291 9.50337 39.5299C9.46365 39.5772 9.42325 39.6255 9.39224 39.6644C9.37817 39.682 9.35395 39.7127 9.32979 39.7472C9.319 39.7627 9.29428 39.7985 9.26829 39.8454C9.25554 39.8684 9.2322 39.9123 9.20965 39.97C9.19452 40.0088 9.14062 40.1482 9.14062 40.3359H11.1406C11.1406 40.5226 11.0871 40.6605 11.0727 40.6974C11.0508 40.7534 11.0286 40.7951 11.0172 40.8155C10.9941 40.8572 10.9736 40.8865 10.9685 40.8939C10.9555 40.9124 10.948 40.9213 10.9558 40.9115C10.9685 40.8956 10.9924 40.8667 11.0352 40.8157C11.1157 40.7198 11.2398 40.5731 11.3904 40.389C11.6927 40.0194 12.1077 39.4922 12.5534 38.8488C13.4361 37.5749 14.4776 35.7916 14.9768 33.8329L13.0388 33.3389ZM9.43352 39.6288C9.19966 39.8627 9.07424 40.1523 9.01682 40.4011C8.95844 40.6541 8.94608 40.9693 9.05132 41.285L10.9487 40.6525C10.9836 40.7573 10.9712 40.8264 10.9656 40.8508C10.9615 40.8686 10.9542 40.8916 10.9399 40.9196C10.9262 40.9462 10.8988 40.9919 10.8477 41.043L9.43352 39.6288ZM9.16795 41.5234C9.29543 41.7147 9.48466 41.9346 9.7813 42.0829C10.0664 42.2254 10.3486 42.25 10.5625 42.25V40.25C10.4952 40.25 10.5664 40.2394 10.6757 40.294C10.7966 40.3545 10.8452 40.4338 10.8321 40.4141L9.16795 41.5234ZM10.5625 42.25C15.5151 42.25 19.25 39.9293 21.0464 38.4323L19.7661 36.8958C18.1875 38.2113 14.8911 40.25 10.5625 40.25V42.25ZM20.0645 38.6039C22.4889 39.4855 25.1356 40 28 40V38C25.38 38 22.9642 37.5302 20.748 36.7243L20.0645 38.6039ZM28 40C38.2608 40 47 33.1984 47 24.375H45C45 31.7234 37.5673 38 28 38V40ZM47 24.375C47 15.6246 38.2642 8.75 28 8.75V10.75C37.5639 10.75 45 17.0941 45 24.375H47Z"
            fill="#EBEBEB"
          />
        </g>
        <circle cx="20" cy="25" r="2" fill="#2E5FF6" />
        <circle cx="28" cy="25" r="2" fill="#2E5FF6" />
        <circle cx="36" cy="25" r="2" fill="#2E5FF6" />
        <defs>
          <filter
            id="filter0_d"
            x="0.972412"
            y="0.75"
            width="54.0276"
            height="49.5"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="4" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  {/if}

  <div
    class="{message_total === 0 || client_typing
      ? 'hideMessageTotal'
      : ''} messageTotal"
  >
    <p>{message_total}</p>
  </div>

  <div class="chatIcon">
    <svg
      width="38"
      height="31"
      viewBox="0 0 38 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.8125 21.375H35.875V15.0469C35.875 14.3438 35.5234 13.582 34.9961 13.0547L29.1953 7.25391C28.668 6.72656 27.9062 6.375 27.2031 6.375H24.625V3.5625C24.625 2.03906 23.3359 0.75 21.8125 0.75H3.0625C1.48047 0.75 0.25 2.03906 0.25 3.5625V22.3125C0.25 23.8945 1.48047 25.125 3.0625 25.125H4C4 28.2305 6.51953 30.75 9.625 30.75C12.7305 30.75 15.25 28.2305 15.25 25.125H22.75C22.75 28.2305 25.2695 30.75 28.375 30.75C31.4805 30.75 34 28.2305 34 25.125H36.8125C37.2812 25.125 37.75 24.7148 37.75 24.1875V22.3125C37.75 21.8438 37.2812 21.375 36.8125 21.375ZM9.625 27.9375C8.04297 27.9375 6.8125 26.707 6.8125 25.125C6.8125 23.6016 8.04297 22.3125 9.625 22.3125C11.1484 22.3125 12.4375 23.6016 12.4375 25.125C12.4375 26.707 11.1484 27.9375 9.625 27.9375ZM28.375 27.9375C26.793 27.9375 25.5625 26.707 25.5625 25.125C25.5625 23.6016 26.793 22.3125 28.375 22.3125C29.8984 22.3125 31.1875 23.6016 31.1875 25.125C31.1875 26.707 29.8984 27.9375 28.375 27.9375ZM33.0625 15.75H24.625V9.1875H27.2031L33.0625 15.0469V15.75Z"
        fill="white"
      />
    </svg>
  </div>
</div>

<style src="./LiveChatIcon.scss">
</style>
